import api from '@/apis'
import Vuetify from '@/plugins/vuetify'

export default {
  state: {
    loading: false,
    items: [],
    search: null,
    search_result: []
  },
  mutations: {
    SET_BOOKMARK_CARD_LOADING(state, payload) {
      state.loading = payload
    },
    SET_BOOKMARK_CARD_ITEMS(state, payload) {
      state.items = payload
    },
    SET_BOOKMARK_CARD_SEARCH(state, payload) {
      state.search = payload
    },
    SET_BOOKMARK_CARD_SEARCH_RESULT(state, payload) {
      state.search_result = payload
    }
  },
  actions: {
    async fetchBookmarkList({ commit }) {
      try {
        commit('SET_BOOKMARK_CARD_LOADING', true)
        commit('SET_BOOKMARK_CARD_ITEMS', [])

        const response = await api.getConversation({ bookmarked: true })
        if (response.data.success) commit('SET_BOOKMARK_CARD_ITEMS', response.data.data)
        else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_BOOKMARK_CARD_LOADING', false)
      }
    },
    async searchBookmarkList({ state, commit }) {
      try {
        commit('SET_BOOKMARK_CARD_LOADING', true)
        commit('SET_BOOKMARK_CARD_SEARCH_RESULT', [])

        const response = await api.getConversation({ bookmarked: true, search: state.search })
        if (response.data.success) commit('SET_BOOKMARK_CARD_SEARCH_RESULT', response.data.data)
        else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_BOOKMARK_CARD_LOADING', false)
      }
    },
    async deleteBookmark({ commit, dispatch }, payload) {
      try {
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: Vuetify.locale.t('$vuetify.__SnackBar.deleting', Vuetify.locale.t('$vuetify.__AI.bookmark')), loading: true })

        const response = await api.bookmarkConversation({ params: payload })
        if (response.data.success) {
          dispatch('fetchBookmarkList')
          dispatch('searchBookmarkList')
          commit('SET_SNACKBAR', {
            status: true,
            color: 'success',
            text: Vuetify.locale.t('$vuetify.__SnackBar.delete', Vuetify.locale.t('$vuetify.__AI.bookmark')),
            icon: 'check',
            timeout: '2000'
          })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    }
  }
}
